// src/stores/products.js

import { writable, derived } from 'svelte/store';
import { daysRemaining } from '$lib/helpers/index.js';
import { prizes } from './prizes.js';

/**
 * productStore holds the full array of product objects.
 * recentWinnersStore holds the array of winner objects.
 */
export let productStore = writable([]);
export let recentWinnersStore = writable([]);

/**
 * activeProductsStore: products with stock > 0
 */
export let activeProductsStore = derived(productStore, ($products) => {
  if (!Array.isArray($products)) return [];
  return $products.filter((item) => item.stock > 0);
});

/**
 * highlightedProductStore: products marked highlighted === true
 */
export let highlightedProductStore = derived(productStore, ($products) => {
  if (!Array.isArray($products)) return [];
  return $products.filter((item) => item.highlighted === true);
});

/**
 * latestProductsStore: from the `prizes` store, filter stock > 0,
 * sort by createdAt ascending, return first 5
 */
export let latestProductsStore = derived(prizes, ($prizes) => {
  if (!Array.isArray($prizes)) return [];
  const available = $prizes.filter((item) => item.stock > 0);
  const sorted = available.sort((a, b) => a.createdAt - b.createdAt);
  return sorted.slice(0, 5);
});

/**
 * endingProductsStore: from `prizes`, select items with daysRemaining(endDate) < 4
 * and stock > 0, up to 5 items
 */
export let endingProductsStore = derived(prizes, ($prizes) => {
  if (!Array.isArray($prizes)) return [];
  const arr = [];
  for (const item of $prizes) {
    const daysLeft = daysRemaining(item?.endDate);
    if (daysLeft < 4 && item.stock > 0) {
      arr.push(item);
      if (arr.length >= 5) break;
    }
  }
  return arr;
});

/**
 * recentlyEndedStore: products with stock === 0
 */
export let recentlyEndedStore = derived(productStore, ($products) => {
  if (!Array.isArray($products)) return [];
  return $products.filter((item) => item.stock === 0);
});
